module.exports = __webpack_public_path__ + "img/not_found.20242df0.svg";